<div class="flex justify-end items-center gap-2 h-12 shrink-0">
  <div *ngIf="expandedSearch" class="relative flex items-center flex-1">
    <i class="pi pi-search absolute left-3 text-gray-400" style="z-index: 10"></i>
    <input
      type="text"
      pInputText
      [(ngModel)]="filter"
      (input)="handleSearch($event.target.value)"
      [placeholder]="searchPlaceholder"
      class="w-full pr-3 py-2 text-sm border-gray-300 focus:border-[var(--primary-500)] transition-colors"
      style="
        padding-left: 2.5rem !important;
        border-radius: 0.5rem !important;
        box-shadow: none !important;
        outline: none !important;
      "
    />
  </div>

  <ng-container *ngIf="!expandedSearch">
    <div
      class="relative overflow-hidden transition-all duration-300 ease-in-out flex items-center"
      [ngClass]="searchOpen ? 'w-64 opacity-100 mr-2' : 'w-0 opacity-0'"
    >
      <i class="pi pi-search absolute left-3 text-gray-400" style="z-index: 10"></i>
      <input
        type="text"
        pInputText
        [(ngModel)]="filter"
        (input)="handleSearch($event.target.value)"
        [placeholder]="searchPlaceholder"
        class="w-full pr-3 py-2 text-sm border-gray-300 focus:border-[var(--primary-500)] transition-colors"
        style="
          padding-left: 2.5rem !important;
          border-radius: 0.5rem !important;
          box-shadow: none !important;
          outline: none !important;
        "
      />
    </div>
    <button
      pButton
      class="p-button-text p-button-rounded w-10 h-10 transition-colors"
      [ngClass]="
        searchOpen
          ? 'text-[var(--primary-500)] bg-blue-50'
          : 'text-gray-500 hover:bg-gray-100'
      "
      [icon]="searchOpen ? 'pi pi-times' : 'pi pi-search'"
      pTooltip="Search"
      tooltipPosition="bottom"
      tooltipStyleClass="custom-tooltip"
      (click)="toggleSearch()"
    ></button>
  </ng-container>

  <button
    *ngIf="showNewButton"
    pButton
    class="p-button-text p-button-rounded text-gray-500 hover:text-[var(--primary-500)] hover:bg-gray-100 w-10 h-10 transition-colors"
    icon="pi pi-plus"
    [pTooltip]="newButtonTooltip"
    tooltipPosition="bottom"
    tooltipStyleClass="custom-tooltip"
    (click)="newClick.emit()"
  ></button>
</div>
